// extracted by mini-css-extract-plugin
export var center = "navbar-module--center--SjdVB";
export var flex = "navbar-module--flex--FZWl-";
export var hideOnDesktop = "navbar-module--hideOnDesktop--9mwCq";
export var img = "navbar-module--img--XwELN";
export var mM = "navbar-module--m-m--IgnLx";
export var mbM = "navbar-module--mb-m--sWsnw";
export var navbar = "navbar-module--navbar--oBvv6";
export var navbar__header = "navbar-module--navbar__header--3BDU+";
export var navbar__logo = "navbar-module--navbar__logo--B5Mkr";
export var navbar__main = "navbar-module--navbar__main--e-IjG";
export var navbar__social = "navbar-module--navbar__social--nC5RF";